var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      attrs: {
        height: "100%"
      }
    },
    [
      _c("gg-card-header", [_vm._v(" Self Resolve ")]),
      _c("gg-card-text", [
        _c(
          "ol",
          _vm._l(_vm.steps, function(step, key) {
            return _c(
              "li",
              {
                key: "step-".concat(key)
              },
              [_vm._v(" " + _vm._s(step) + " ")]
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }